app = angular.module("seismology")
app.directive 'contenteditable', ($window)->
    require: 'ngModel'
    restrict: 'A'
    link: (scope, elm, attr, ngModel) ->
      updateViewValue = ->
        ngModel.$setViewValue @innerHTML
      elm.on 'keyup', updateViewValue
      scope.$on '$destroy', ->
        elm.off 'keyup', updateViewValue
      ngModel.$render = ->
        elm.html ngModel.$viewValue
      # allow only plain text
      elm.on 'paste', (e) ->
        e.preventDefault()
        text = e.clipboardData.getData("text/plain")
        document.execCommand("insertHTML", false, text)

app.directive 'focusOn', ->
  (scope, elem, attr) ->
    scope.$on attr.focusOn, (e)-> elem[0].focus()

app.directive 'execOnScrollBottom', ->
  restrict: 'A'
  link: (scope, element, attrs) ->
    raw = element[0]    
    element.on 'scroll', ->            
      if (raw.scrollTop + raw.offsetHeight == raw.scrollHeight)
        scope.$eval(attrs.execOnScrollBottom)
      

app.directive 'diamond', ->
  restrict: 'E'
  scope:
    'count': '@'
  link: (scope, element, attrs) ->    
    attrs.$observe 'count', ()->
      scope.count1 = parseInt(scope.count)
      scope.count2 = 5-scope.count1
      scope.arr1 = new Array(scope.count1)
      scope.arr2 = new Array(scope.count2)
  template: """
    <div class='diamond'>
      <img ng-repeat='c in arr1 track by $index' src='resources/img/diamond.png'>
      <img ng-repeat='c in arr2 track by $index' src='resources/img/diamond_inactive.png'>
    </div>
  """

app.directive 'openProfile', ($mdDialog)->
  restrict: 'A'
  link: (scope, element, attrs) ->
    element.addClass('open-profile')
    diagName = attrs.openDialog
    element.on 'click', ->
      console.log scope.$eval(attrs.locals)
      $mdDialog.show
        controller: "ProfileDialogCtrl"
        templateUrl: "templates/dialogs/profile.html"
        parent: angular.element(document.body)
        clickOutsideToClose: true
        locals: {user: scope.$eval(attrs.openProfile)}

      
app.directive 'openLikes', ($mdDialog)->
  restrict: 'A'
  link: (scope, element, attrs) ->
    element.addClass('open-likes')
    diagName = attrs.openDialog
    element.on 'click', ->
      console.log scope.$eval(attrs.locals)
      $mdDialog.show
        controller: "LikesDialogCtrl"
        templateUrl: "templates/dialogs/likes.html"
        parent: angular.element(document.body)
        clickOutsideToClose: true
        locals: {likes: scope.$eval(attrs.openLikes)}

      
app.directive 'errSrc', ->
  { link: (scope, element, attrs) ->
    element.bind 'error', ->
      if attrs.src != attrs.errSrc
        attrs.$set 'src', attrs.errSrc
      return
    return
 }





// WEBPACK FOOTER //
// ./app/directives.coffee